'use strict';

angular.module('clientDashboardApp').service('mediaService', function ($q, $http, pagingService) {
    function MediaService() {
    }

    MediaService.prototype.mediaReport = function (mediaOptions, callback) {
        var reportUrl = '/dashboard/mediaReport';
        return pagingService.createSearch(reportUrl, mediaOptions, callback);
    };

    MediaService.prototype.updateUserFeedback = function (mediaItem) {
        return $http.put('/dashboard/updateUserFeedback',mediaItem);
    };

    return new MediaService();
});
